// Cart persisted in localStorage. Items are {id, plan_id, plan_name, price_brl, hostname, os}.
import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "flixvps_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch {}
  }, [items]);

  const addItem = (plan) => {
    const item = {
      id: `${plan.plan_id}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      plan_id: plan.plan_id,
      plan_name: plan.name,
      price_brl: plan.price_brl,
      hostname: "",
      os: "ubuntu-20.04-x86_64",
    };
    setItems((prev) => [...prev, item]);
  };

  const updateItem = (id, patch) => setItems((prev) => prev.map((it) => (it.id === id ? { ...it, ...patch } : it)));
  const removeItem = (id) => setItems((prev) => prev.filter((it) => it.id !== id));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, it) => s + Number(it.price_brl || 0), 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateItem, removeItem, clear, subtotal, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
